import type { FC } from 'react'
import React from 'react'
import { Typography, useTheme } from '@mui/material'
import useFavurTranslation from 'hooks/useFavurTranslation'
import Divider from 'redesign/components/atoms/Divider'
import CmsContentHistory from 'redesign/components/molecules/cms-content-history'
import type { Audience } from 'types'
import { Container, TeamsWrapper } from './styles'
import type { CmsContentFooterProps } from './types'
import { getAudienceName } from './utils'

const CmsContentFooter: FC<CmsContentFooterProps> = ({ createdHistory, updatedHistory, audiences }) => {
  const { palette } = useTheme()
  const { t, locale } = useFavurTranslation()

  return (
    <Container>
      <Divider fullSize fullWidth />
      {createdHistory && <CmsContentHistory history={createdHistory} />}
      {updatedHistory && <CmsContentHistory history={updatedHistory} />}
      <TeamsWrapper>
        <Typography variant="body1" color={palette.grey[400]}>
          {`${t('page.cms.content.target')} ${
            locale && audiences && audiences.map((audience: Audience) => getAudienceName({ audience, t, locale }))
          }`}
        </Typography>
      </TeamsWrapper>
    </Container>
  )
}

export default CmsContentFooter
